import styles from './Ajuda.module.scss';
export const Ajuda = () => {

  return (
    <div className={styles.page}>

      <div className={styles.containerSobre}>
        <p className={styles.titulo}>
        COMO FUNCIONA?
        </p>
        <p className={styles.frase}>
        Encontre seus produtos favoritos
        </p>
        <p className={styles.frase}>
        e economize tempo e dinheiro.
        </p>
        <p className={styles.frase}>
        Pague suas compras com total segurança
        </p>
        <p className={styles.frase}>
        e venda seus produtos de forma segura.
        </p>
      </div>
    </div>
  );

};